<template>
    <div class="plugin-detail">
        <pay-box title="插件购买" padding="24px">
            <div class="plugin-box">
                <div class="detail">
                    <div class="thumb">

                    </div>
                    <div class="info">
                        <div class="name">在线视频</div>
                        <div class="summary">
                            沉浸式交互与深度分析：插件不仅限于播放，更为互动与增长而设计。支持弹幕互动、时间戳打点、章节导航与关联内容推荐等功能，大幅提升用户参与度与停留时长。
                        </div>
                        <div class="price">
                            <span>价格：</span>
                            <span>¥</span>
                            <span>288.00</span>
                        </div>
                        <div class="btn-row">
                            <div class="pay" @click="payClick">立即购买</div>
                            <div class="back" @click="backClick">返回</div>
                        </div>
                    </div>
                </div>
            </div>
        </pay-box>
        <pay-box title="插件详情" padding="24px">
            <div class="plugin-box">
                <div v-html="detail"></div>
            </div>
        </pay-box>
    </div>

</template>

<script>
import PayBox from "@/views/AST/Pay/Step/PayBox.vue";
export default {
    name: "PluginDetail",
    components: {
        PayBox
    },
    data() {
        return {
            detail: `
                <p>沉浸式交互与深度分析：插件不仅限于播放，更为互动与增长而设计。支持弹幕互动、时间戳打点、章节导航与关联内容推荐等功能，大幅提升用户参与度与停留时长。</p>
                <p>功能丰富：插件提供多种功能，包括视频播放、弹幕互动、时间戳打点、章节导航、关联内容推荐等。用户可以根据需要选择开启或关闭某项功能。</p>
                <p>用户友好：插件界面简洁明了，操作方便。用户无需复杂配置，即可开始使用。</p>
            `
        }
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        backClick() {
            this.$router.back();
        },
        payClick() {
            
        },
        getDetail() {
            
        },
    }
}
</script>

<style scoped lang="less">
.plugin-box {
    .detail {
        display: flex;

        .thumb {
            width: 492px;
            height: 276px;
            background: #999;
            margin-right: 24px;
        }

        .info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            
            .name {
                color: #333;
                font-size: 24px;
                font-weight: bold;
            }

            .summary {
                height: 138px;
                color: #999;
                font-size: 16px;
                line-height: 22px;
                margin-top: 16px;
                // 滚动条
                overflow: auto;
            }

            .price {
                span {
                    &:nth-child(1) {
                        color: #999;
                        font-size: 16px;
                    }

                    &:nth-child(2) {
                        color: #E52553;
                        font-size: 14px;
                    }

                    &:nth-child(3) {
                        color: #E52553;
                        font-size: 24px;
                    }
                }
            }

            .btn-row {
                margin-top: 18px;
                display: flex;

                .pay {
                    width: 108px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #333333;
                    color: #fff;
                    font-size: 14px;
                    margin-right: 16px;
                    cursor: pointer;
                }

                .back {
                    width: 80px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    color: #333333;
                    font-size: 14px;
                    border: 1px solid #333333;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>